import Vue from 'vue';
import Router from 'vue-router';
// import Overview from 'components/Overview';
// import Benchmark from 'components/Benchmark';
// import NewsDashboard from 'components/NewsDashboard';
// import CompanyList from 'components/CompanyList';
// import EconomyPredictor from 'components/EconomyPredictor';
// import OrgCharts from 'components/OrgCharts';
// import Job from 'components/Job';
// import Zhaopin from 'components/Zhaopin';
// import UniGrads from 'components/UniGrads';
// import Disruptive from 'components/Disruptive';
// import HrVisualizer from 'components/HrVisualizer';
// import MinWage from 'components/MinWage';
// import Legislation from 'components/Legislation';
// import HrNews from 'components/HrNews';
// import BizNews from 'components/BizNews';
// import NewsTagger from 'components/NewsTagger';
// import ExecutivePay from 'components/ExecutivePay';
// import HrPredictors from 'components/HrPredictors';
// import Admin from 'components/Admin';
// import CostOfLiving from 'components/CostOfLiving';
// import LivingCostCities from 'components/LivingCostCities';
// import FreshGraduateSalary from 'components/FreshGraduateSalary';

const CompetitorsMatrix = () =>
  import(/* webpackChunkName: "a" */ 'components/CompetitorsMatrix');
const SuppliersMatrix = () =>
  import(/* webpackChunkName: "a" */ 'components/SuppliersMatrix');
const CustomersMatrix = () =>
  import(/* webpackChunkName: "a" */ 'components/CustomersMatrix');
const InstitutionMatrix = () =>
  import(/* webpackChunkName: "a" */ 'components/InstitutionMatrix');
const HrMatrix = () =>
  import(/* webpackChunkName: "a" */ 'components/HrMatrix');

const SalaryAdmin = () =>
  import(/* webpackChunkName: "a" */ 'components/SalaryAdmin');
const BonusAdmin = () =>
  import(/* webpackChunkName: "a" */ 'components/BonusAdmin');
const AttritionAdmin = () =>
  import(/* webpackChunkName: "a" */ 'components/AttritionAdmin');
const ModuleUsageAdmin = () =>
  import(/* webpackChunkName: "a" */ 'components/ModuleUsageAdmin');
const WebsiteLegislationAdmin = () =>
  import(/* webpackChunkName: "a" */ 'components/WebsiteLegislationAdmin');
const WebsiteEbiAdmin = () =>
  import(/* webpackChunkName: "a" */ 'components/WebsiteEbiAdmin');
const WebsiteEconAdmin = () =>
  import(/* webpackChunkName: "a" */ 'components/WebsiteEconAdmin');
const CompanyAdmin = () =>
  import(/* webpackChunkName: "a" */ 'components/companyAdmin/CompanyAdmin');
const HrNews = () =>
  import(/* webpackChunkName: "a" */ 'components/HrNews');
const BizNews = () =>
  import(/* webpackChunkName: "a" */ 'components/BizNews');
const NewsDashboard = () =>
  import(/* webpackChunkName: "a" */ 'components/NewsDashboard');
const NewsTagger = () =>
  import(/* webpackChunkName: "a" */ 'components/NewsTagger');
const Admin = () =>
  import(/* webpackChunkName: "a" */ 'components/Admin');
const ForecastCalculator = () =>
  import(/* webpackChunkName: "a" */ 'components/forecast/ForecastCalculator');
// const ExecutivePay = () => import(/* webpackChunkName: "a" */ 'components/ExecutivePay');
const CompanyList = () =>
  import(/* webpackChunkName: "a" */ 'components/CompanyList');
const Disruptive = () =>
  import(/* webpackChunkName: "a" */ 'components/Disruptive');
const FreshGraduateSalary = () =>
  import(/* webpackChunkName: "a" */ 'components/FreshGraduateSalary');
const CostOfLiving = () =>
  import(/* webpackChunkName: "a" */ 'components/CostOfLiving');
const CostOfLivingTrends = () =>
  import(/* webpackChunkName: "a" */ 'components/CostOfLivingTrends');
const LivingCostCities = () =>
  import(/* webpackChunkName: "a" */ 'components/LivingCostCities');
const Benchmark = () =>
  import(/* webpackChunkName: "a" */ 'components/Benchmark');
const EconomyPredictor = () =>
  import(/* webpackChunkName: "a" */ 'components/EconomyPredictor');
// const UniGrads = () =>
//   import(/* webpackChunkName: "a" */ 'components/UniGrads');
const HrVisualizer = () =>
  import(/* webpackChunkName: "a" */ 'components/HrVisualizer');
const MinWage = () =>
  import(/* webpackChunkName: "a" */ 'components/MinWage');
const Overview = () =>
  import(/* webpackChunkName: "a" */ 'components/Overview');
const Job = () =>
  import(/* webpackChunkName: "a" */ 'components/Job');
const Legislation = () =>
  import(/* webpackChunkName: "a" */ 'components/Legislation');
const GenderDiversity = () =>
  import(/* webpackChunkName: "a" */ 'components/GenderDiversity');

Vue.use(Router);

export default new Router({
  routes: [{
    path: '/fm',
    name: 'Organisation and Productivity Benchmark',
    component: Benchmark,
    meta: {
      permissions: ['mds', 'aims.nonrewards', 'all', 'finance_productivity'],
    },
    props: ({ query }) => {
      const props = {
        country: query.country,
        sector: +query.sector,
        indicator: query.indicator,
      };
      return props;
    },
  },
  {
    path: '/gender',
    name: 'Gender Diversity',
    component: GenderDiversity,
    meta: {
      permissions: ['mds', 'aims.nonrewards', 'all', 'finance_productivity'],
    },
  },
  {
    path: '/job',
    name: 'Jobs Postings',
    component: Job,
    meta: {
      permissions: ['mds', 'aims.nonrewards', 'all', 'hr_markets'],
    },
    props: ({ query }) => {
      const props = {
        country: query.country,
        sector: +query.sector,
      };
      return props;
    },
  },
  // {
  //   path: '/zhaopin',
  //   name: 'Zhaopin',
  //   component: Zhaopin,
  //   meta: {
  //     permissions: ['mds', 'all'],
  //   },
  // },
  {
    path: '/legislation',
    name: 'Legislation',
    component: Legislation,
    meta: {
      permissions: ['mds', 'aims.nonrewards', 'all', 'legislations_news'],
    },
  },
  {
    path: '/minwage',
    name: 'Wages',
    component: MinWage,
    meta: {
      permissions: ['mds', 'all', 'pay_trends'],
    },
    props: ({ query }) => {
      const props = {
        country: query.country,
      };
      return props;
    },
  },
  {
    path: '/hr',
    name: 'Talent Supply Indicators',
    component: HrVisualizer,
    meta: {
      permissions: ['mds', 'aims.nonrewards', 'all', 'hr_markets'],
    },
    props: ({ query }) => {
      const props = {
        region: query.region,
        indicatorGroup: query.indicatorGroup,
      };
      return props;
    },
  },
  {
    path: '/newstagger',
    name: 'News Tagger',
    component: NewsTagger,
    meta: {
      permissions: ['news_tagger', 'all'],
    },
  },
  // {
  //   path: '/ugrads',
  //   name: 'University Graduates Supply',
  //   component: UniGrads,
  //   meta: {
  //     permissions: ['mds', 'aims.nonrewards', 'all', 'hr_markets'],
  //   },
  //   props: ({ query }) => {
  //     const props = {
  //       country: query.country,
  //     };
  //     return props;
  //   },
  // },
  {
    path: '/macro',
    name: 'Economy',
    component: EconomyPredictor,
    meta: {
      permissions: ['mds', 'aims.nonrewards', 'all', 'economy'],
    },
    props: ({ query }) => {
      const props = {
        indicator: query.indicator,
        country: {
          countryCode: query.countryCode,
          countryName: query.countryName,
        },
      };
      return props;
    },
  },
  {
    path: '/costofliving',
    name: 'Relocation Calculator',
    component: CostOfLiving,
    meta: {
      permissions: ['mds', 'aims.nonrewards', 'all', 'relocation'],
    },
  },
  {
    path: '/citiescost',
    name: 'Cities Living Cost',
    component: LivingCostCities,
    meta: {
      permissions: ['mds', 'aims.nonrewards', 'all', 'relocation'],
    },
  },
  {
    path: '/coltrends',
    name: 'Cost of Living Trends',
    component: CostOfLivingTrends,
    meta: {
      permissions: ['mds', 'aims.nonrewards', 'all', 'relocation'],
    },
  },
  {
    path: '/companyinfo',
    name: 'CompanyInfo',
    component: CompanyList,
    meta: {
      permissions: ['mds', 'aims.nonrewards', 'all'],
    },
  },
  {
    path: '/planning',
    name: 'Entities-based Strategic Planning',
    component: Overview,
    meta: {
      permissions: ['mds', 'all', 'aims.nonrewards', 'news_tagger'],
    },
  },
  {
    path: '/companyMatrix/customers',
    name: 'Customers Matrix',
    component: CustomersMatrix,
    meta: {
      permissions: ['mds', 'aims.nonrewards', 'all', 'finance_productivity'],
    },
  },
  {
    path: '/companyMatrix/suppliers',
    name: 'Suppliers Matrix',
    component: SuppliersMatrix,
    meta: {
      permissions: ['mds', 'aims.nonrewards', 'all', 'finance_productivity'],
    },
  },
  {
    path: '/companyMatrix/competitors',
    name: 'Competitors Matrix',
    component: CompetitorsMatrix,
    meta: {
      permissions: ['mds', 'aims.nonrewards', 'all', 'finance_productivity'],
    },
  },
  {
    path: '/hrMatrix',
    name: 'HR Matrix',
    component: HrMatrix,
    meta: {
      permissions: ['mds', 'aims.nonrewards', 'all', 'hr_markets'],
    },
  },
  {
    path: '/institution',
    name: 'Institution',
    component: InstitutionMatrix,
    meta: {
      permissions: ['mds', 'aims.nonrewards', 'all'],
    },
  },
  {
    path: '/disruptive',
    name: 'Disruptive',
    component: Disruptive,
    meta: {
      permissions: ['mds', 'aims.nonrewards', 'all'],
    },
  },
  // {
  //   path: '/orgstructure',
  //   name: 'Org Structure',
  //   component: OrgCharts,
  //   meta: {
  //     permissions: ['mds', 'aims.nonrewards', 'all'],
  //   },
  // },
  {
    path: '/hrpredict',
    name: 'Salary/Bonus Increase Forecast',
    component: ForecastCalculator,
    meta: {
      permissions: ['mds', 'all', 'aims.nonrewards', 'forecast_calculator'],
    },
  },
  {
    path: '/admin',
    name: 'Admin Module',
    component: Admin,
    meta: {
      permissions: ['all'],
    },
    children: [{
      path: 'salary',
      name: 'Salary Admin Module',
      component: SalaryAdmin,
    },
    {
      path: 'bonus',
      name: 'Bonus Admin Module',
      component: BonusAdmin,
    },
    {
      path: 'attrition',
      name: 'Attrition Admin Module',
      component: AttritionAdmin,
    },
    {
      path: 'moduleUsage',
      name: 'Client Module Usage',
      component: ModuleUsageAdmin,
    },
    {
      path: 'companyAdmin',
      name: 'Finance & Productivity Admin Module',
      component: CompanyAdmin,
    },
    {
      path: 'website/legislation',
      name: 'Website Legislation Update Upload',
      component: WebsiteLegislationAdmin,
    },
    {
      path: 'website/ebi',
      name: 'Website EBI Upload',
      component: WebsiteEbiAdmin,
    },
    {
      path: 'website/econ_guide',
      name: 'Website Econ Guide Upload',
      component: WebsiteEconAdmin,
    },
    ],
  },
  {
    path: '/news',
    name: 'News',
    component: NewsDashboard,
    meta: {
      permissions: ['mds', 'aims.nonrewards', 'all', 'legislations_news'],
    },
    children: [{
      path: 'hr',
      name: 'HR News',
      component: HrNews,
    },
    {
      path: 'biz',
      name: 'Business News',
      component: BizNews,
      props: ({ query }) => {
        const props = {
          countryLocal: query.country,
        };
        return props;
      },
    },
    ],
  },
  // {
  //   path: '/finance/:country/:sector',
  //   name: 'Finance',
  //   component: FinancialDashboard,
  //   props: true,
  // },
  {
    path: '/freshgradsal',
    name: 'Fresh Graduate Start Rates',
    component: FreshGraduateSalary,
    meta: {
      permissions: ['mds', 'all', 'pay_trends'],
    },
  },
    // {
    //   path: '/exePay',
    //   name: 'Executive Pay',
    //   component: ExecutivePay,
    //   meta: {
    //     permissions: ['mds', 'all', 'pay_trends'],
    //   },
    //   props: ({
    //     query,
    //   }) => {
    //     const props = {
    //       country: query.country,
    //       sector: +query.sector,
    //       indicator: query.indicator,
    //     };
    //     return props;
    //   },
    // },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js